import { forwardRef, useEffect, useRef, useState } from "react";

import { TextInput, TextInputRef } from "../TextInput";
import { ListItemProps, SelectionInputProps } from "./types";
import { DropDown } from "../../../assets";
import { useComponentVisible } from "../../../hooks";
import { styles } from "./styles";
import { theme } from "../../../layout";

export const SelectionInput = forwardRef<TextInputRef, SelectionInputProps>(
  ({ items = [], selectedIndex, setSelectedIndex, ...rest }, ref) => {
    const parentRef = useRef<HTMLDivElement>(null);
    const [dropdownWidth, setDropdownWidth] = useState(0);

    useEffect(() => {
      if (parentRef.current) {
        setDropdownWidth(parentRef.current.offsetWidth);
      }
    }, []);

    const {
      ref: divRef,
      isComponentVisible,
      setIsComponentVisible,
    } = useComponentVisible(false);

    const onClickInput = () => {
      setIsComponentVisible(true);
    };

    return (
      <div ref={parentRef} onClick={onClickInput}>
        <TextInput
          rightIcon={<DropDown />}
          ref={ref}
          readOnly
          onClick={onClickInput}
          onRightIconClick={onClickInput}
          {...rest}
        />
        {isComponentVisible && items.length ? (
          <div
            ref={divRef}
            style={{
              ...styles.wrapper,
              width: dropdownWidth,
            }}
          >
            <div style={styles.container} onClick={(e) => e.stopPropagation()}>
              {items.map((item, index) => {
                return (
                  <ListItem
                    label={item}
                    onClick={() => {
                      setIsComponentVisible(false);
                      setSelectedIndex(index);
                    }}
                  />
                );
              })}
            </div>
          </div>
        ) : null}
      </div>
    );
  }
);

export const ListItem = ({ label, onClick }: ListItemProps) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <span
      style={{
        ...styles.item,
        backgroundColor: isHovered
          ? theme.item.highlight
          : theme.item.background,
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={onClick}
    >
      {label}
    </span>
  );
};
